import { z } from "zod/v4";
export const insuranceNetworkValues = [
    "almerys",
    "viamedis",
    "isante",
    "seveane",
    "itelis",
    "santeclair",
    "carte_blanche",
];
export const insuranceNetworksPreferenceSchema = z.object({
    almerys: z.boolean(),
    viamedis: z.boolean(),
    isante: z.boolean(),
    seveane: z.boolean(),
    itelis: z.boolean(),
    santeclair: z.boolean(),
    carte_blanche: z.boolean(),
});
export const defaultInsuranceNetworks = {
    almerys: false,
    viamedis: false,
    isante: false,
    seveane: false,
    itelis: false,
    santeclair: false,
    carte_blanche: false,
};
export const insuranceNetworkLabels = {
    almerys: "Almerys",
    viamedis: "Viamedis",
    isante: "ISanté",
    seveane: "Sévéane",
    itelis: "Itelis",
    santeclair: "Santéclair",
    carte_blanche: "Carte Blanche",
};
//# sourceMappingURL=InsuranceNetworks.js.map